import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import DropletOptions from '../_bubble-options';
import EditModalOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('modal', {
  template: require('./template.html'),
  name: 'modal',
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    watchDroplets() {
      return this.droplet.droplets.length < 1 ? 'drzDroplet-puddleDropped' : '';
    },
    draggingTemplateDrp() {
      return this.globalDragEl === 'templateDroplet';
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .selector' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    const renderKey = Date.now();
    return {
      type: dropletSchema.type,
      renderKey,
      hasActiveChild: false,
      display: {
        transform: null,
        perspective: null,
        width: null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
        'font-size': null,
        'padding-left': null,
        'padding-right: ': null,
        'padding-top:': null,
        'padding-bottom': null,
        'box-shadow': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: [
    'block-index',
    'droplet',
    'items',
    'index',
    'canvas',
  ],
  components: {
    DropletOptions,
    EditModalOptions,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (id && this.droplet._id !== id) {
        const activeDroplets = this.$el.querySelectorAll(`#drp-${id}`);
        if (activeDroplets.length > 0) {
          this.hasActiveChild = true;
        }
      } else {
        this.hasActiveChild = false;
      }
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.selector',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    'droplet.droplets': function watchDroplets() {
      // bouncing the component key will force a re-render. This is needed
      // for dragula to re insert the draggable container. See @/directives/main.js
      this.renderKey = Date.now();
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/modal/index.js